export class ChatMessageInputTextarea {
    // internal textarea input value
    private _value!: string;

    // value passed from outside and set as initial value on the textarea input
    public value!: string;

    public onChange?: (data: { $value: string }) => void;
    public onSubmit?: (data: { $value: string }) => void;
    public onKeydown?: (data: { $event: any }) => void;

    $onInit() {
        this._value = this.value;
    }

    $onChanges(changes: ng.IOnChangesObject) {
        // the message might get cleared from outside components
        if (this._value != changes.value?.currentValue) {
            this._value = changes.value?.currentValue;
        }
    }

    keydown(event: KeyboardEvent) {
        const KEY_ENTER = 13;

        if (event.keyCode === KEY_ENTER && event.shiftKey !== true && event.ctrlKey !== true) {
            event.preventDefault();
            this.submit(this._value);
        }
    }

    change() {
        this.onChange && this.onChange({ $value: this._value });
    }

    submit(value: string) {
        this.onSubmit && this.onSubmit({ $value: value });
    }
}

angular.module('tradersyard').component('tyChatMessageInputTextarea', {
    // language=HTML
    template: `<textarea ng-model="$ctrl._value"
                             ng-change="$ctrl.change()"
                             ng-keydown="$ctrl.keydown($event)"
                             placeholder="{{$ctrl.placeholder}}">
        </textarea>`,
    controller: ChatMessageInputTextarea,
    bindings: {
        value: '<',
        placeholder: '@',
        onChange: '&',
        onKeydown: '&',
        // usually triggered by pressing Enter, but might change based on the key-map
        onSubmit: '&?',
    },
});
